/**
 * 号码补零标准化：1-49 补零为两位，其它保留原样
 */
export function normalizeBallNum(val) {
  const s = String(val == null ? '' : val).trim()
  if (!s) return ''
  const n = parseInt(s, 10)
  if (Number.isNaN(n) || n < 1 || n > 49) return s.length <= 2 ? s.padStart(2, '0') : s
  return n < 10 ? `0${n}` : String(n)
}

/**
 * 逗号/中文逗号分割
 */
export function splitCsv(s) {
  if (s == null || s === '') return []
  return String(s)
    .split(/[,，]/)
    .map(x => x.trim())
    .filter(Boolean)
}

/**
 * API 波色标准化（未知返回空字符串）
 */
export function normalizeApiTone(c) {
  if (c == null || typeof c !== 'string') return ''
  const x = c.trim().toLowerCase()
  if (x === 'red' || x === 'blue' || x === 'green') return x
  return ''
}

/**
 * 历史波色标准化（未知返回 'blue'）
 */
export function normalizeHistoryTone(c) {
  if (c == null || typeof c !== 'string') return 'blue'
  const x = c.trim().toLowerCase()
  if (x === 'red' || x === 'blue' || x === 'green') return x
  return 'blue'
}

/**
 * 查波色表返回 'red' | 'blue' | 'green'
 * @param {string} val 球号
 * @param {{ red: string[], blue: string[], green: string[] }} tables 波色号码表
 */
export function waveTone(val, tables) {
  const n = normalizeBallNum(val)
  if (tables.red.includes(n)) return 'red'
  if (tables.blue.includes(n)) return 'blue'
  if (tables.green.includes(n)) return 'green'
  return 'blue'
}

const ELEMENT_MAP = {
  '01': '水','02': '火','03': '火','04': '金','05': '金',
  '06': '土','07': '土','08': '木','09': '木','10': '火',
  '11': '火','12': '金','13': '金','14': '水','15': '水',
  '16': '木','17': '木','18': '火','19': '火','20': '土',
  '21': '土','22': '水','23': '水','24': '木','25': '木',
  '26': '金','27': '金','28': '土','29': '土','30': '水',
  '31': '水','32': '火','33': '火','34': '金','35': '金',
  '36': '土','37': '土','38': '木','39': '木','40': '火',
  '41': '火','42': '金','43': '金','44': '水','45': '水',
  '46': '木','47': '木','48': '火','49': '火'
}

/**
 * 根据号码获取五行
 * @param {string} num - 标准化号码（如 '01'）
 * @returns {string}
 */
export function numberToElement(num) {
  return ELEMENT_MAP[num] || ''
}

/**
 * 球对象工厂
 */
export function createBall(value, zodiac, element, tone) {
  return {
    value: normalizeBallNum(value),
    zodiac: zodiac || '',
    element: element || '',
    tone: tone || ''
  }
}
